import React from 'react';
import MobileNavBar from '../components/complexComponents/MobileNavBar';
import NavBar from '../components/complexComponents/NavBar';
import blue from '../assets/img/blue.jpg';
import { useProgressiveImage } from '../utils/hooks';
import Header from '../components/complexComponents/Header';


function PortalHeader({
	portal,
	routing,
	setRouting,
	colors,
	translate,
}) {
	/* Sections variables */
	const [desktopSections, setDesktopSections] = React.useState();
	const [mobileSections, setMobileSections] = React.useState();

	// Lazy loading images so they dont blink
	const lazyLoadImage = useProgressiveImage(portal?.config?.header?.bgImage);

	// Desktop sections dont include home
	const getDesktopSections = React.useCallback(() => {
		const deskSections = portal?.config?.sections ?
			Object.values(portal?.config?.sections)
				.filter(section => section.isActive && section.value !== 'home')
			: [];
		if (!portal?.config?.sections?.documents.isActive
			|| portal?.attachments?.length <= 3) {
			return deskSections.filter(section => section.value !== 'documents');
		}
		return deskSections;
	}, [portal?.config?.sections]);

	// Mobile sections include home
	const getMobileSections = React.useCallback(() => {
		const mobSections = portal?.config?.sections ?
			Object.values(portal?.config?.sections)
				.filter(section => section.isActive)
			: [];
		if (!portal?.config?.sections?.documents.isActive
			|| portal?.attachments?.length <= 3) {
			return mobSections.filter(section => section.value !== 'documents');
		}
		return mobSections;
	}, [portal?.config?.sections]);

	React.useEffect(() => {
		setDesktopSections(getDesktopSections());
		setMobileSections(getMobileSections());
	}, [getDesktopSections, getMobileSections]);

	return <React.Fragment>

		{/* HEADER */}
		<Header
			mobileMenuOptions={mobileSections}
			routing={routing}
			setRouting={setRouting}
			portal={portal}
			colors={colors}
			support={portal?.config?.footer?.links?.support}
			translate={translate} />

		{/* MOBILE NAVIGATION BAR */}
		{routing !== 'home'
		&& <MobileNavBar
			sections={mobileSections}
			colors={colors}
			translate={translate}
			routing={routing}
			setRouting={setRouting} />
		}

		{/* NAVIGATION BAR */}
		{routing !== 'home'
		&& <NavBar
			sections={desktopSections}
			bgImg={lazyLoadImage ?? blue}
			routing={routing}
			setRouting={setRouting}
			colors={colors}
			translate={translate} />
		}
	</React.Fragment>;
}

export default PortalHeader;
